/**
 * usePermissions Hook
 * Custom hook for checking user permissions throughout the application
 */

import { useAuth } from '../contexts/AuthContext';
import { 
  getUserPermissions, 
  hasPermission, 
  hasAnyPermission, 
  hasAllPermissions,
  PERMISSIONS 
} from '../config/permissions';

export const usePermissions = () => {
  const { user } = useAuth();

  return {
    // Get all user permissions
    permissions: getUserPermissions(user),
    
    // Check single permission
    can: (permission) => hasPermission(user, permission),
    
    // Check if user has any of the permissions
    canAny: (permissionsList) => hasAnyPermission(user, permissionsList),
    
    // Check if user has all permissions
    canAll: (permissionsList) => hasAllPermissions(user, permissionsList),
    
    // Expose PERMISSIONS constant for easy access
    PERMISSIONS,
    
    // User info
    user,
  };
};

export default usePermissions;

